import classes from './HowWorks.module.css';

const HowWorks = () => {
  return (
    <div className={classes.howWorksContainer}>
      <aside className={classes.howWorksDescription}>
        <p className={classes.title}>¿Cómo funciona?</p>
        <p className={classes.principalText}>
          Ofrece tus cursos en línea a nivel internacional a través
          de tu propia Academia, de la EduStore o de ambas. Acepta
          pagos desde cualquier país y recibe los depósitos
          directamente en tu cuenta bancaria.
        </p>
      </aside>
      <div className={classes.contenTypes}>
        <p className={classes.title}>Academia Pública</p>
        <p className={classes.secondaryText}>
          Crea en minutos tu propia tienda de cursos y campus en
          línea. Vende tus cursos y entrega diplomas en forma
          automatizada con una experiencia de usuario de clase
          mundial. Puedes personalizarla con tu imagen de marca,
          ligarla a tu página web principal, habilitar tu propio
          catálogo de cursos y vender esos cursos al público en
          general, recibiendo directamente los ingresos generados por
          tus ventas.
        </p>
      </div>
      <div className={classes.contenTypes}>
        <p className={classes.title}>EduStore</p>
        <p className={classes.secondaryText}>
          La EduStore es la tienda global de cursos operada por
          Mayahii, con presencia en más de 50 países. Puedes publicar
          tus cursos en la EduStore desde el panel de administración
          de tu Academia, sin ningún costo adicional. A través de la
          EduStore, amplía la exposición de tus cursos a toda la red
          de usuarios Mayahii y recibe directamente los ingresos por
          tus ventas. Puedes ofrecer tus cursos solo en tu Academia,
          solo en la EduStore, o en ambas al mismo tiempo.
        </p>
      </div>
      <div className={classes.contenTypes}>
        <p className={classes.title}>Academia Privada</p>
        <p className={classes.secondaryText}>
          Brinda tus cursos de forma privada a tus propios usuarios y
          entrega diplomas en forma automatizada con una experiencia
          de clase mundial. Puedes personalizarla con tu imagen de
          marca, ligarla a tu página web principal, habilitar tu
          propio catálogo de cursos y dar acceso solo a quien tu lo
          desees a través de códigos de acceso controlados por ti.
        </p>
      </div>
    </div>
  );
};

export default HowWorks;
